const  { parsePhoneNumber } =  require('libphonenumber-js');

const phoneNumberFormatUS = (phone_number) => {
  if (phone_number == null || phone_number == '') {
    return '';
  }

  try {
    const phoneNumber = parsePhoneNumber(phone_number, 'US')
    if(phoneNumber) {
      if (phoneNumber.isValid()) {
       
        const nationalNumber = phoneNumber.nationalNumber;
        const phoneFormatUS = `${ nationalNumber.substring(0, 3) }-${ nationalNumber.substring(3, 6) }-${ nationalNumber.slice(-4)}`;
        return phoneFormatUS;
      }
    }
  } catch (e) {
    return '';
  }
}

const phoneNumberMask = (phone_number) => {
    if (phone_number == null || phone_number == '') {
      return '';
    }

    try {
      const phoneNumber = parsePhoneNumber(phone_number, 'US')
      if (phoneNumber && phoneNumber.isValid()) {
        const cleanPhone = phone_number.replace(/[^\d]+/g, "");
        const lenPhone = cleanPhone.length;

        if (lenPhone == 10) return `(${ cleanPhone.substring(0, 3) }) ${ cleanPhone.substring(3, 6) }-${ cleanPhone.slice(-4)}`;

        if (lenPhone == 11) return `+${ cleanPhone.substring(0, 1) } (${ cleanPhone.substring(1, 4) }) ${ cleanPhone.substring(4, 7) }-${ cleanPhone.slice(-4)}`;
      }
    }
    catch (e) {
      return '';
    }
    return '';
}

const cleanPhoneNumber = (phone_number,country_code) => {

  if (phone_number == null || phone_number == '') {
    return '';
  }
  try {
    const phoneNumber = parsePhoneNumber(phone_number, country_code)
    if(phoneNumber) {
      if (phoneNumber.isValid()) { 
        return phoneNumber.number;
      }
    }
  } catch(e) {
    return '';
  }
  return '';
  
}

// Enhanced phone number validation using libphonenumber-js
const enhancedPhoneNumberValidation = (phone_number, country_code = 'US') => {
  if (!phone_number || phone_number === '') return false;
  
  try {
    const phoneNumber = parsePhoneNumber(phone_number, country_code);
    
    if (!phoneNumber || !phoneNumber.isValid()) {
      return false;
    }
    
    // Check if the country is in the allowed list (US, CA, PR, VI)
    const validCountries = ['US', 'CA', 'PR', 'VI'];
    if (!validCountries.includes(phoneNumber.country)) {
      return false;
    }
    
    return true;
  } catch (e) {
    console.error('Phone validation error:', e);
    return false;
  }
}

// HERA-8859: Resolve the ISO country of a stored number (US and CA share the
// +1 calling code, so the area code is what distinguishes them) purely so the
// UI can render the matching flag. Returns null when the number is missing or
// not yet valid, letting callers keep their own default rather than being
// forced to 'US' while the user is still typing.
const getPhoneNumberCountry = (phone_number, country_code = 'US') => {
  if (!phone_number || phone_number === '') return null;

  try {
    const phoneNumber = parsePhoneNumber(phone_number, country_code);
    if (!phoneNumber || !phoneNumber.isValid()) {
      return null;
    }
    return phoneNumber.country || null;
  } catch (e) {
    return null;
  }
}

const validatePhoneNumberFormat = (records) => {
  return records.map((item) => {
    const validated = validatedRecordPhone(item.phone);
    const phone = getPhoneNumber(validated, item.phone);
    
    // Apply enhanced validation using libphonenumber-js
    const finalValidated = validated && enhancedPhoneNumberValidation(phone);
    
    return {
      ...item,
      phone,
      validated: finalValidated
    };
  });
}
const validateDevicePhoneNumberFormat = (records) => {
  return records.map((item) => {
    const validated = validatedRecordPhone(item.phoneNumber)
    const phone = getPhoneNumber(validated, item.phoneNumber)

    const finalValidated = validated && enhancedPhoneNumberValidation(phone)
    return {
      ...item,
      phone,
      validated: finalValidated
    };
  });
}

const validatePhoneNumberFormatSingle = (phone_number) => {
  if (phone_number == null) return true;
  if (phone_number == '') return true;
  const onlyNumbers = phone_number.replace(/[^\d]+/g, "");
  if (onlyNumbers.length !== 10 && onlyNumbers.length !== 11) return false;
  // Strip leading country code '1' if 11 digits for parsePhoneNumber
  const normalizedPhone = onlyNumbers.length === 11 && onlyNumbers.startsWith('1')
    ? onlyNumbers.substring(1)
    : onlyNumbers;
  const validatePhoneNumber = parsePhoneNumber(normalizedPhone, 'US');
  if( validatePhoneNumber ) {
    if (!validatePhoneNumber.isValid()) { 
      return false;
    }
    else {
      phone_number = validatePhoneNumber.number
    }
  } else {
    return false
  }
  
  // Use enhanced validation instead of Telnyx API
  return enhancedPhoneNumberValidation(phone_number);
}

function validatedRecordPhone(phone){
  if (!phone || phone === '') return true;
  const onlyNumbers = phone.replace(/[^\d]+/g, "");
  if (onlyNumbers.length !== 10 && onlyNumbers.length !== 11) return false;
  // Strip leading country code '1' if 11 digits for parsePhoneNumber
  const normalizedPhone = onlyNumbers.length === 11 && onlyNumbers.startsWith('1')
    ? onlyNumbers.substring(1)
    : onlyNumbers;
  const validatePhoneNumber = parsePhoneNumber(normalizedPhone, 'US');
  return validatePhoneNumber && validatePhoneNumber.isValid();
}

function getPhoneNumber(validated, phone){
  if(phone && phone !== '' && validated){
    const validatePhoneNumber = parsePhoneNumber(phone, 'US');
    return validatePhoneNumber.number
  }
  return phone
}

const formatPhoneNumber = (phone) => {
  if (phone == null || phone === '') return phone;
  try {
    const parsed = parsePhoneNumber(phone, 'US');
    if (parsed && parsed.isValid()) {
      return parsed.formatInternational().replace(/ /g, '-');
    }
    return phone;
  } catch (e) {
    return phone;
  }
}

module.exports = {
    validatePhoneNumberFormat,
    validatePhoneNumberFormatSingle,
    cleanPhoneNumber,
    phoneNumberFormatUS,
    phoneNumberMask,
    validatedRecordPhone,
    validateDevicePhoneNumberFormat,
    enhancedPhoneNumberValidation,
    formatPhoneNumber,
    getPhoneNumberCountry,
}
